module.exports = __webpack_public_path__ + "img/17.fce48f1a.jpg";